import { useState } from "react";
import { toast } from "sonner";
import { Cloud } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import ConfirmDialog from "@/components/common/ConfirmDialog";
import { errMsg, useApi } from "@/lib/api";

export default function EdgeToggle({ site, onSaved }) {
  const api = useApi();
  const [ask, setAsk] = useState(null);
  const h = site.hosting;
  if (!h.available) return null;
  const save = async () => {
    const v = ask;
    setAsk(null);
    try { await api.patch(`/sites/${site.id}`, { edge_enabled: v }); toast.success(v ? `Pubblicazione su «${h.available_label}» attivata: ora compila il sito` : "Pubblicazione esterna disattivata"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-lg border border-sky-200 bg-sky-50/50 p-3" data-testid="site-edge-toggle">
      <label className="flex items-start gap-3">
        <Switch checked={h.edge_enabled} onCheckedChange={(v) => setAsk(v)} data-testid="site-edge-switch" />
        <span className="text-sm text-slate-700"><span className="inline-flex items-center gap-1.5 font-medium"><Cloud size={14} className="text-sky-600" />Pubblica su «{h.available_label}»</span>
          <span className="block text-xs text-slate-500">Attivo solo per questo sito: gli altri siti restano sul server interno. La pubblicazione online resta sempre manuale.</span></span>
      </label>
      <ConfirmDialog open={ask !== null} onOpenChange={(o) => !o && setAsk(null)} onConfirm={save} destructive={ask === false}
        confirmLabel={ask ? "Attiva" : "Disattiva"} title={ask ? `Pubblicare «${site.name}» su «${h.available_label}»?` : `Disattivare la pubblicazione esterna di «${site.name}»?`}
        description={ask ? "Dalla prossima compilazione l'anteprima di questo sito va sull'hosting esterno (indirizzo -anteprima, noindex). Niente viene pubblicato online finché non usi «Pubblica online»."
          : "Gli indirizzi esterni di questo sito (anteprima e online) smettono subito di rispondere. Le prossime compilazioni restano sul server interno."} />
    </div>
  );
}
